import type { UserDeletionImpact, UserResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { AdministratorsGateway } from './administrators.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the Administrators index endpoints (kept 1:1 with the original `Administrators`
 * page's `useApi('/users?role=admin')` + archive `PATCH`). Sorting is a pure
 * domain concern applied in the selector, not here.
 */
export const httpAdministratorsGateway: AdministratorsGateway = {
  fetchAdministrators: () => api.get<UserResponse[]>('/users?role=admin'),
  setArchived: async (id: string, archived: boolean) => {
    await api.patch(`/users/${id}/archive`, { archived });
  },
  deleteAdministrator: async (id: string) => {
    await api.delete(`/users/${id}`);
  },
  fetchDeletionImpact: (id: string) => api.get<UserDeletionImpact>(`/users/${id}/deletion-impact`),
};
